import { render, staticRenderFns } from "./chapterdialog.vue?vue&type=template&id=a05a6d20&scoped=true"
import script from "./chapterdialog.vue?vue&type=script&lang=js"
export * from "./chapterdialog.vue?vue&type=script&lang=js"
import style0 from "./chapterdialog.vue?vue&type=style&index=0&id=a05a6d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05a6d20",
  null
  
)

export default component.exports